import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_elccldtdr7: FaireBrandEntity = {
  token: "b_elccldtdr7",
  type: "brand",
  name: "Imported Brand One",
  avatarUrl: "https://cdn.faire.com/fastly/example-brand-logo.jpeg",
  bannerUrl: "https://cdn.faire.com/fastly/example-brand-hero.jpeg",
  logoUrl: "https://cdn.faire.com/fastly/example-brand-logo.jpeg",
  heroImageUrl: "https://cdn.faire.com/fastly/example-brand-hero.jpeg",
  location: "United States",
  minimumOrderDollars: 150,
  rating: 4.8,
  description: "Canonical imported brand entity.",
  meta: {
    source: "api",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "entity-db-bootstrap",
  },
};
